import React from "react";
import useCreateUser from "../../customHooks/CreateUser/useCreateUser";
import { Modal } from "react-bootstrap";
import { Loader as LoaderIcon } from "react-feather";

const CreateUserModal = ({ show, onHide, fetchUsers, id, userData }) => {
  const {
    userDetails,
    submitLoader,
    errors,
    handleChange,
    setErrors,
    setUserDetails,
    handleBlur,
    renderErrorMessage,
    handleSubmit,
    roles,
  } = useCreateUser({ id, fetchUsers, onHide, userData });
  return (
    <div>
      <Modal
        show={show}
        onHide={() => {
          onHide();
          setUserDetails({ sName: "", sDescription: "" });
          setErrors({});
        }}
        size="lg"
      >
        <Modal.Header closeButton>
          <h1 className="font-bold text-xl">
            {id ? "Update User" : "Create User"}
          </h1>
        </Modal.Header>
        <Modal.Body>
          <div className="bg-[#f9fafb] p-[15px]">
            <form>
              <div className="form-box">
                <div className="form-section">
                  <div className="flex gap-4">
                    <div className="form-group w-1/2">
                      <label htmlFor="username">
                        User Name <span className="red">*</span>
                      </label>
                      <input
                        type="text"
                        name="username"
                        id="username"
                        value={userDetails.username ?? ""}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        placeholder="Enter Feature Name"
                      />
                      {renderErrorMessage("username") && (
                        <div className="text-left text-small  color_red inputErrorSection">
                          {renderErrorMessage("username")}
                        </div>
                      )}
                    </div>
                    <div className="form-group w-1/2">
                      <label htmlFor="email">
                        Email <span clasemail="red">*</span>
                      </label>
                      <input
                        type="email"
                        name="email"
                        id="email"
                        value={userDetails.email ?? ""}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        placeholder="Enter Feature Name"
                      />
                      {renderErrorMessage("email") && (
                        <div className="text-left text-small  color_red inputErrorSection">
                          {renderErrorMessage("email")}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="form-group">
                    <label htmlFor="role">
                      Role <span className="red">*</span>
                    </label>
                    <select
                      id="role"
                      name="role"
                      value={userDetails.role ?? ""}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      // disabled={selectedFeature}
                    >
                      <option value={""}>Select Option</option>
                      {roles.map((role) => {
                        return <option value={role.id}>{role.name}</option>;
                      })}
                    </select>
                    {renderErrorMessage("role") && (
                      <div className="text-left text-small  color_red inputErrorSection">
                        {renderErrorMessage("role")}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </form>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="flex justify-between gap-6">
            {submitLoader ? (
              <button
                className="save-button"
                style={{ width: "100px" }}
                disabled={submitLoader}
              >
                <LoaderIcon size={20} className="indicator" />
              </button>
            ) : (
              <button
                type="submit"
                className="save-button"
                disabled={submitLoader}
                onClick={handleSubmit}
              >
                {id ? "Update" : "Save"}
              </button>
            )}
            <button
              type="submit"
              className="cancel-button"
              onClick={() => {
                setUserDetails({ username: "", email: "", role: "" });
                setErrors({});
                onHide();
              }}
            >
              Cancel
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default CreateUserModal;
